import React from 'react'
import { IconContext } from 'react-icons'
import { FaInfoCircle } from '@react-icons/all-files/fa/FaInfoCircle'

const ClickableIcon = (props) => {
  return (
    <div
      onClick={props.onClick}
      className={`clickable-icon-wrapper ${props.hasSubText ? 'clickable-icon-wrapper--subtext-position' : ''} ${props.isTsCsIcon ? 'clickable-icon-wrapper--ts-and-cs-icon' : ''}`}>
      <IconContext.Provider value={{color: '#68C9D0', borderRadius: 25}}>
        <FaInfoCircle color='#68C9D0' />
      </IconContext.Provider>
    </div>
  )
}

export default ClickableIcon
